import { useContext, useEffect, useState } from 'react'
import MapContext from '../MapContext'
import { Draw as OlDraw } from 'ol/interaction';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { DrawTypes, FeatureTypes, endDrawing, startDrawing } from '../../../../features/drawSlice';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style, { StyleLike } from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import Circle from 'ol/style/Circle';
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';
import { toLonLat } from 'ol/proj';
import { getArea, getLength } from 'ol/sphere';
import * as turf from '@turf/turf'

export default function Draw() {

    const map = useContext(MapContext)
    const drawType = useAppSelector(state => state.drawState.drawType)
    const is3d = useAppSelector(state => state.toolbarState.show3d)
    const textStatus = useAppSelector(state => state.drawState.text)
    const ol3D = useAppSelector(state => state.mapState.ol3D)
    const [source] = useState(new VectorSource())
    const dispatch = useAppDispatch()
    const activeLanguage = useAppSelector(state => state.language.activeLanguage);

    useEffect(() => {
        const drawLayer = new VectorLayer({
            source, zIndex: 10000,
            style: (setStyle as any),
            visible: !is3d
        });
        map.addLayer(drawLayer);

        return () => {
            map.removeLayer(drawLayer);
        }
    }, [])


    useEffect(() => {
        let draw: OlDraw | undefined;
        if (is3d) {
            const position: any = []
            const screenSpaceEventHandler = new (window as any).Cesium.ScreenSpaceEventHandler(ol3D.getCesiumScene().canvas);
            const entities = ol3D.getDataSourceDisplay().defaultDataSource.entities
            const camera = ol3D.getCesiumScene().camera
            const Color = (window as any).Cesium.Color
            const Cartesian2 = (window as any).Cesium.Cartesian2
            const LabelStyle = (window as any).Cesium.LabelStyle
            const ScreenSpaceEventType = (window as any).Cesium.ScreenSpaceEventType
            const HeightReference = (window as any).Cesium.HeightReference
            switch (drawType) {
                case DrawTypes.POINT:
                    screenSpaceEventHandler.setInputAction((click: any) => {
                        var clickPosition = camera.pickEllipsoid(click.position);
                        const pointEntity = entities.add({
                            position: clickPosition,
                            point: {
                                heightReference: HeightReference.CLAMP_TO_GROUND,
                                outlineColor: (window as any).Cesium.Color.WHITE,
                                pixelSize: 10,
                                color: Color.AQUA,
                                outlineWidth: 2
                            },
                            label: {
                                text: `${clickPosition.x.toFixed(2)},  ${clickPosition.y.toFixed(2)},  ${clickPosition.z.toFixed(2)}`,
                                font: "24px Helvetica",
                                fillColor: Color.WHITE,
                                outlineColor: Color.BLACK,
                                outlineWidth: 3,
                                fontSize: 10,
                                style: LabelStyle.FILL_AND_OUTLINE,
                                pixelOffset: new Cartesian2(0, -19)
                            },
                            zIndex: 10
                        });
                        // pointEntity.point!.hierarchy = position;

                        // ol3D.getCesiumScene().entities.remove(pointEntity);
                        screenSpaceEventHandler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
                        dispatch(startDrawing(DrawTypes.DEFAULT))
                        // this.removeInputActionHandler([clickPosition], FeatureTypes.POINT);
                    }, ScreenSpaceEventType.LEFT_CLICK)
                    break;
                case DrawTypes.LINESTRING:
                    screenSpaceEventHandler.setInputAction((click: any) => {
                        // var distance = (window as any).Cesium.Cartesian3.distance(position[0].x, position[position.length].x);
                        const polylineEntity = entities.add({
                            polyline: { material: Color.AQUA },
                            // label: {
                            //     id: 'my label',
                            //     text: 'זה טקסט בעברית \n ועכשיו יורדים שורה',
                            //     verticalOrigin: (window as any).Cesium.VerticalOrigin.TOP,
                            //     horizontalOrigin: (window as any).Cesium.HorizontalOrigin.RIGHT,
                            //     font :'300px sans-serif'
                            //   }
                        })
                        var clickPosition = camera.pickEllipsoid(click.position);
                        position.push(clickPosition);
                        polylineEntity.polyline!.positions = position;

                        // Polyline tipindeki entity'nin pozisyonlarını alıyoruz
                        var positionsArray = polylineEntity.polyline.positions.getValue();

                        // Pozisyonları degree cinsine çeviriyoruz
                        var positionsDegrees = positionsArray.map((pos:any) => {
                            var cartographicPos =  (window as any).Cesium.Cartographic.fromCartesian(pos);
                            return [ (window as any).Cesium.Math.toDegrees(cartographicPos.longitude),  (window as any).Cesium.Math.toDegrees(cartographicPos.latitude)];
                        });

                        // Toplam mesafeyi hesaplıyoruz
                        var totalDistance = 0;
                        for (var i = 0; i < positionsDegrees.length - 1; i++) {
                            var from = positionsDegrees[i];
                            var to = positionsDegrees[i + 1];
                            var options:any = { units: 'meters' };
                            totalDistance += turf.distance(from, to, options);
                        }

                        // polylineEntity.label = new (window as any).Cesium.LabelGraphics({
                        //     text : 'My Marker',
                        //     font : '14pt monospace',
                        //     horizontalOrigin : (window as any).Cesium.HorizontalOrigin.CENTER,
                        //     pixelOffset : new (window as any).Cesium.Cartesian2(0, -10)
                        // });
                  

                        const context = () => {
                            // entities.remove(polylineEntity);
                            (window as any).Cesium.Label.enableRightToLeftDetection = true;
                            polylineEntity.text = 'טקסט חדש';
                            screenSpaceEventHandler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
                            dispatch(startDrawing(FeatureTypes.NONE))
                            document.removeEventListener('contextmenu', context)
                        }
                        document.addEventListener('contextmenu', () => {
                            context();
                        })
                    }, ScreenSpaceEventType.LEFT_CLICK)
                    break;
                case DrawTypes.POLYGON:
                    const polygonEntity = entities.add({
                        polygon: {
                            material: new Color(0, 1, 1, 0.4)
                        },
                        label: {
                            text: "Philadelphia",
                        }
                    });
                    const contextPolygon = () => {
                        // viewer.entities.remove(polygonEntity);
                        screenSpaceEventHandler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
                        dispatch(startDrawing(FeatureTypes.NONE))
                        document.removeEventListener('contextmenu', contextPolygon)
                    }
                    document.addEventListener('contextmenu', () => {
                        contextPolygon();
                    })
                    screenSpaceEventHandler.setInputAction((click: any) => {
                        var clickPosition = camera.pickEllipsoid(click.position);
                        position.push(clickPosition);
                        polygonEntity.polygon!.hierarchy = position;
                    }, ScreenSpaceEventType.LEFT_CLICK)
                    // screenSpaceEventHandler.setInputAction((click: any) => {
                    //     var clickPosition = camera.pickEllipsoid(click.position);
                    //     position.pop(clickPosition);
                    //     polygonEntity.polygon!.hierarchy = position;
                    // }, ScreenSpaceEventType.RIGHT_CLICK)
                    break;
                case DrawTypes.CLEAR:
                    entities.removeAll();

                    break;
                default:
                    break;

            }
            return () => {
                screenSpaceEventHandler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            }
        } else {
            switch (drawType) {
                case DrawTypes.POINT:
                    draw = new OlDraw({ type: 'Point', source, style: (setStyle as any), stopClick: true })
                    break;
                case DrawTypes.LINESTRING:
                    draw = new OlDraw({ type: 'LineString', source, style: (setStyle as any), stopClick: true })
                    break;
                case DrawTypes.POLYGON:
                    draw = new OlDraw({ type: 'Polygon', source, style: (setStyle as any), stopClick: true })
                    break;
                case DrawTypes.CLEAR:
                    source.clear();
                    break;
                default:
                    break;
            }
            if (draw) {
                map.addInteraction(draw);
                map.on('click', clickMapForDraw)
                draw.on('drawend', (e) => {
                    dispatch(endDrawing(e.feature));
                })
            }
        }

        return () => {
            if (draw) {
                map.removeInteraction(draw);
                map.un('click', clickMapForDraw)
            }
        }
    }, [drawType, activeLanguage])


    const clickMapForDraw = (e: any) => {
        // console.log(e);
    }

    const setStyle = (feature: Feature): StyleLike | undefined => {
        let style;
        let text;
        const geomType: any = feature.getGeometry()?.getType();
        switch (geomType) {
            case 'Point':
                text = toLonLat((feature.getGeometry() as Point)?.getCoordinates()).map((obj: any) => obj.toFixed(6)).join(',');
                style = new Style({
                    text: new Text({
                        text,
                        font: '13px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial,' +
                            ' sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        stroke: new Stroke({
                            color: '#000000',
                            width: 3
                        }),
                        fill: new Fill({
                            color: '#ffffff'
                        }),
                        offsetY: -15
                    }),
                    image: new Circle({
                        radius: 5,
                        fill: new Fill({
                            color: '#00FFFF90',
                        }),
                    })
                })
                break;
            case 'LineString':
                if (textStatus) {
                    text = getLength((feature.getGeometry() as LineString))?.toFixed(3) + ' m';
                }
                style = new Style({
                    stroke: new Stroke({
                        color: '#00FFFF',
                        width: 2
                    }),
                    text: new Text({
                        text,
                        font: '12px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial,' +
                            ' sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        stroke: new Stroke({
                            color: '#000000',
                            width: 3
                        }),
                        fill: new Fill({
                            color: '#ffffff'
                        }),
                        offsetY: -15
                    })
                })
                break;
            case 'Polygon':
                if (textStatus) {
                    text = getArea((feature.getGeometry() as LineString))?.toFixed(3) + ' m²';
                }
                style = new Style({
                    stroke: new Stroke({
                        color: '#00FFFF',
                        width: 2
                    }),
                    fill: new Fill({
                        color: '#00FFFF50'
                    }),
                    text: new Text({
                        text,
                        font: '12px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial,' +
                            ' sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        stroke: new Stroke({
                            color: '#000000',
                            width: 3
                        }),
                        fill: new Fill({
                            color: '#ffffff'
                        }),
                        offsetY: -15
                    })
                })
                break;

            default:
                break;
        }
        return style as StyleLike;
    }


    return (
        <></>
    )
}
